import { interceptor } from '@/common/utils/interceptor';
import * as Constants from '@/common/utils/constants';

export default [
  {
    path: '/appointment/schedule',
    component: () => import('@/pages/appointment/schedule'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_NO);
    }
  },
  {
    path: '/appointment/area',
    component: () => import('@/pages/appointment/area'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_NO, [], '选择专家类型');
    }
  }, {
    path: '/appointment/depart',
    component: () => import('@/pages/appointment/depart'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_NO, [], '选择医生');
    }
  }, {
    path: '/appointment/doctor',
    component: () => import('@/pages/appointment/doctor'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN, [], '选择号源');
    }
  }, {
    path: '/appointment/confirm',
    component: () => import('@/pages/appointment/confirm'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN, [], '确认预约');
    }
  }, {
    path: '/appointment/complete',
    component: () => import('@/pages/appointment/complete'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN, [], '预约成功');
    }
  }, {
    path: '/appointment/record',
    component: () => import('@/pages/appointment/record'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN, [], '挂号预约记录');
    }
  }, {
    path: '/appointment/record-info',
    component: () => import('@/pages/appointment/record-info'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
    }
  }, {
    path: '/appointment/search',
    component: () => import('@/pages/appointment/search'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN, [], '搜索医生');
    }
  }
];
